export const PermissionCodes = {
  DASHBOARD_VIEW: "DASHBOARD_VIEW",
  CLIENTS_LIST: "CLIENTS_LIST",
  CLIENTS_VIEW: "CLIENTS_VIEW",
  CLIENTS_CREATE: "CLIENTS_CREATE",
  CLIENTS_EDIT: "CLIENTS_EDIT",
  CLIENTS_DELETE: "CLIENTS_DELETE",
  ORGANIZATIONS_LIST: "ORGANIZATIONS_LIST",
  ORGANIZATIONS_VIEW: "ORGANIZATIONS_VIEW",
  ORGANIZATIONS_CREATE: "ORGANIZATIONS_CREATE",
  ORGANIZATIONS_EDIT: "ORGANIZATIONS_EDIT",
  ORGANIZATIONS_DELETE: "ORGANIZATIONS_DELETE",
  USERS_LIST: "USERS_LIST",
  USERS_VIEW: "USERS_VIEW",
  USERS_CREATE: "USERS_CREATE",
  USERS_EDIT: "USERS_EDIT",
  USERS_DELETE: "USERS_DELETE",
  PATIENTS_LIST: "PATIENTS_LIST",
  PATIENTS_VIEW: "PATIENTS_VIEW",
  PATIENTS_CREATE: "PATIENTS_CREATE",
  PATIENTS_EDIT: "PATIENTS_EDIT",
  PATIENTS_DELETE: "PATIENTS_DELETE",
  DOCTORS_LIST: "DOCTORS_LIST",
  DOCTORS_VIEW: "DOCTORS_VIEW",
  DOCTORS_CREATE: "DOCTORS_CREATE",
  DOCTORS_EDIT: "DOCTORS_EDIT",
  DOCTORS_DELETE: "DOCTORS_DELETE",
  PROVIDERS_LIST: "PROVIDERS_LIST",
  PROVIDERS_VIEW: "PROVIDERS_VIEW",
  PROVIDERS_CREATE: "PROVIDERS_CREATE",
  PROVIDERS_EDIT: "PROVIDERS_EDIT",
  PROVIDERS_DELETE: "PROVIDERS_DELETE",
  HEALTHCARE_PAYOR_LIST: "HEALTHCARE_PAYOR_LIST",
  HEALTHCARE_PAYOR_VIEW: "HEALTHCARE_PAYOR_VIEW",
  HEALTHCARE_PAYOR_CREATE: "HEALTHCARE_PAYOR_CREATE",
  HEALTHCARE_PAYOR_EDIT: "HEALTHCARE_PAYOR_EDIT",
  HEALTHCARE_PAYOR_DELETE: "HEALTHCARE_PAYOR_DELETE",
  CREDENTIALING_TRACKING_LIST: "CREDENTIALING_TRACKING_LIST",
  CREDENTIALING_TRACKING_VIEW: "CREDENTIALING_TRACKING_VIEW",
  CREDENTIALING_TRACKING_CREATE: "CREDENTIALING_TRACKING_CREATE",
  CREDENTIALING_TRACKING_EDIT: "CREDENTIALING_TRACKING_EDIT",
  CREDENTIALING_TRACKING_DELETE: "CREDENTIALING_TRACKING_DELETE",
  ROLES_LIST: "ROLES_LIST",
  ROLES_VIEW: "ROLES_VIEW",
  ROLES_CREATE: "ROLES_CREATE",
  ROLES_EDIT: "ROLES_EDIT",
  ROLES_DELETE: "ROLES_DELETE",
  EMAIL_TEMPLATES_LIST: "EMAIL_TEMPLATES_LIST",
  EMAIL_TEMPLATES_CREATE: "EMAIL_TEMPLATES_CREATE",
  EMAIL_TEMPLATES_EDIT: "EMAIL_TEMPLATES_EDIT",
  EMAIL_TEMPLATES_DELETE: "EMAIL_TEMPLATES_DELETE",
  LOCATIONS_LIST: "LOCATIONS_LIST",
  LOCATIONS_VIEW: "LOCATIONS_VIEW",
  LOCATIONS_CREATE: "LOCATIONS_CREATE",
  LOCATIONS_EDIT: "LOCATIONS_EDIT",
  LOCATIONS_DELETE: "LOCATIONS_DELETE",
  STAFFS_LIST: "STAFFS_LIST",
  STAFFS_VIEW: "STAFFS_VIEW",
  STAFFS_CREATE: "STAFFS_CREATE",
  STAFFS_EDIT: "STAFFS_EDIT",
  STAFFS_DELETE: "STAFFS_DELETE",
  DOCUMENTS_LIST: "AEGIS_AI_DOCUMENTS_LIST",
  DOCUMENTS_VIEW: "AEGIS_AI_DOCUMENTS_VIEW",
  DOCUMENTS_CREATE: "AEGIS_AI_DOCUMENTS_CREATE",
  DOCUMENTS_EDIT: "AEGIS_AI_DOCUMENTS_EDIT",
  DOCUMENTS_DELETE: "AEGIS_AI_DOCUMENTS_DELETE",
  AGENT_BUILDER_LIST: "AEGIS_AI_AGENT_BUILDER_LIST",
  AGENT_BUILDER_VIEW: "AEGIS_AI_AGENT_BUILDER_VIEW",
  AGENT_BUILDER_CREATE: "AEGIS_AI_AGENT_BUILDER_CREATE",
  AGENT_BUILDER_EDIT: "AEGIS_AI_AGENT_BUILDER_EDIT",
  AGENT_BUILDER_DELETE: "AEGIS_AI_AGENT_BUILDER_DELETE",
  ASSIST_VIEW: "AEGIS_AI_ASSIST_VIEW",
  SUBSCRIPTION_PLANS_LIST: "SUBSCRIPTION_PLANS_LIST",
  SUBSCRIPTION_PLANS_VIEW: "SUBSCRIPTION_PLANS_VIEW",
  SUBSCRIPTION_PLANS_CREATE: "SUBSCRIPTION_PLANS_CREATE",
  SUBSCRIPTION_PLANS_EDIT: "SUBSCRIPTION_PLANS_EDIT",
  SUBSCRIPTION_PLANS_DELETE: "SUBSCRIPTION_PLANS_DELETE",
  SUBSCRIBERS_LIST: "SUBSCRIBERS_LIST",
  SUBSCRIBERS_VIEW: "SUBSCRIBERS_VIEW",
  SUBSCRIBERS_CANCEL: "SUBSCRIBERS_CANCEL",
  APPOINTMENTS_LIST: "APPOINTMENTS_LIST",
  APPOINTMENTS_VIEW: "APPOINTMENTS_VIEW",
  APPOINTMENTS_CREATE: "APPOINTMENTS_CREATE",
  APPOINTMENTS_EDIT: "APPOINTMENTS_EDIT",
  APPOINTMENTS_CANCEL: "APPOINTMENTS_CANCEL",
  CONFIG_LIST: "CONFIG_LIST",
  CONFIG_VIEW: "CONFIG_VIEW",
  CONFIG_CREATE: "CONFIG_CREATE",
  CONFIG_EDIT: "CONFIG_EDIT",
  CONFIG_DELETE: "CONFIG_DELETE",
  LOGIN_CREDS_LIST: "LOGIN_CREDS_LIST",
  LOGIN_CREDS_VIEW: "LOGIN_CREDS_VIEW",
  LOGIN_CREDS_CREATE: "LOGIN_CREDS_CREATE",
  LOGIN_CREDS_EDIT: "LOGIN_CREDS_EDIT",
  LOGIN_CREDS_DELETE: "LOGIN_CREDS_DELETE",
  REPORTS_RUN: "REPORTS_RUN",
  AUDIT_LOGS_LIST: "AUDIT_LOGS_LIST",
  AUDIT_LOGS_VIEW: "AUDIT_LOGS_VIEW",
  SERVICES_LIST: "SERVICES_LIST",
  SERVICES_VIEW: "SERVICES_VIEW",
  SERVICES_CREATE: "SERVICES_CREATE",
  SERVICES_EDIT: "SERVICES_EDIT",
  SERVICES_DELETE: "SERVICES_DELETE",
  CODING_AI_VIEW: "CODING_AI_VIEW",
  ANALYTICS_VIEW: "ANALYTICS_VIEW",
  ANALYTICS_ORGANIZATIONS_LIST: "ANALYTICS_ORGANIZATIONS_LIST",
  ANALYTICS_ORGANIZATIONS_VIEW: "ANALYTICS_ORGANIZATIONS_VIEW",
  ANALYTICS_PATIENTS_LIST: "ANALYTICS_PATIENTS_LIST",
  ANALYTICS_PATIENTS_VIEW: "ANALYTICS_PATIENTS_VIEW",
  ANALYTICS_PRODUCTIVITY_LIST: "ANALYTICS_PRODUCTIVITY_LIST",
  ANALYTICS_PRODUCTIVITY_VIEW: "ANALYTICS_PRODUCTIVITY_VIEW",
  ANALYTICS_AI_VIEW: "ANALYTICS_AI_VIEW",
  INCENTIVE_CONFIG_LIST: "INCENTIVE_CONFIG_LIST",
  INCENTIVE_CONFIG_VIEW: "INCENTIVE_CONFIG_VIEW",
  INCENTIVE_CONFIG_CREATE: "INCENTIVE_CONFIG_CREATE",
  INCENTIVE_CONFIG_EDIT: "INCENTIVE_CONFIG_EDIT",
  INCENTIVE_CONFIG_DELETE: "INCENTIVE_CONFIG_DELETE",
  VALUE_BASED_CARE_LIST: "VALUE_BASED_CARE_LIST",
  VALUE_BASED_CARE_VIEW: "VALUE_BASED_CARE_VIEW",
  
  CLAIM_SUBMISSION_CREATE:"CLAIM_SUBMISSION_CREATE",
  CLAIM_SUBMISSION_EDIT:"CLAIM_SUBMISSION_EDIT",
  CLAIM_SUBMISSION_DELETE:"CLAIM_SUBMISSION_DELETE",
  CLAIM_SUBMISSION_VIEW:"CLAIM_SUBMISSION_VIEW",
  CLAIM_SUBMISSION_LIST:"CLAIM_SUBMISSION_LIST",

  CLAIM_STATUS_CREATE:"CLAIM_STATUS_CREATE",
  CLAIM_STATUS_EDIT:"CLAIM_STATUS_EDIT",
  CLAIM_STATUS_DELETE:"CLAIM_STATUS_DELETE",
  CLAIM_STATUS_VIEW:"CLAIM_STATUS_VIEW",
  CLAIM_STATUS_LIST:"CLAIM_STATUS_LIST",
  
  ELIGIBILITY_VERIFICATION_CREATE:"ELIGIBILITY_VERIFICATION_CREATE",
  ELIGIBILITY_VERIFICATION_EDIT:"ELIGIBILITY_VERIFICATION_EDIT",
  ELIGIBILITY_VERIFICATION_DELETE:"ELIGIBILITY_VERIFICATION_DELETE",
  ELIGIBILITY_VERIFICATION_VIEW:"ELIGIBILITY_VERIFICATION_VIEW",
  ELIGIBILITY_VERIFICATION_LIST:"ELIGIBILITY_VERIFICATION_LIST",

  FEE_SCHEDULE_ANALYTICS_LIST: "FEE_SCHEDULE_ANALYTICS_LIST",
  FEE_SCHEDULE_ANALYTICS_VIEW: "FEE_SCHEDULE_ANALYTICS_VIEW",
};

export const normalizePermissionCodes = (permissions = []) => {
  if (!Array.isArray(permissions)) {
    return [];
  }
  

  return permissions
    .map((permission) => {
      if (!permission) return null;
      if (typeof permission === "string") return permission;
      return (
        permission.Code ||
        permission.code ||
        permission.PermissionCode ||
        permission.permission_code ||
        permission.Permission?.Code ||
        permission.Permission?.code ||
        permission.Permission ||
        permission.Name ||
        permission.name ||
        null
      );
    })
    .filter(Boolean);
};

export const isSuperAdminUser = (user = {}) => {
  if (!user) return false;
  const isSuperAdminFlag =
    user.is_super_admin ??
    user.isSuperAdmin ??
    user.IsSuperAdmin ??
    user.is_superadmin ??
    user.IsSuperadmin;
  if (isSuperAdminFlag === true || isSuperAdminFlag === "true" || isSuperAdminFlag === 1) {
    return true;
  }
  const roleName = (
    user.role ||
    user.Role?.Name ||
    user.Role?.name ||
    user.Role ||
    user.role_name ||
    user.RoleName ||
    ""
  )
    .toString()
    .toLowerCase()
    .trim();

  return (
    roleName === "super admin" ||
    roleName === "superadmin" ||
    roleName === "super_admin"
  );
};

export const permissionHas = (permissionCodes = [], permission, user = {}) => {
  if (!permission) return true;
  if (isSuperAdminUser(user)) return true;

  const normalizedCodes = normalizePermissionCodes(permissionCodes);
  if (Array.isArray(permission)) {
    return permission.some((perm) => normalizedCodes.includes(perm));
  }
  return normalizedCodes.includes(permission);
};

export const resolveUserPermissionCodes = ({ permissions = [], decodedToken = {} } = {}) => {
  const codes =
    Array.isArray(permissions) && permissions.length > 0
      ? permissions
      : Array.isArray(decodedToken?.Permissions)
        ? decodedToken.Permissions
        : Array.isArray(decodedToken?.permissions)
          ? decodedToken.permissions
          : Array.isArray(decodedToken?.permissionCodes)
            ? decodedToken.permissionCodes
            : [];
  return normalizePermissionCodes(codes);
};

export const hasAnyPermission = (permissionCodes = [], requiredPermissions = [], user = {}) => {
  if (!Array.isArray(requiredPermissions) || requiredPermissions.length === 0) {
    return false;
  }

  if (isSuperAdminUser(user)) return true;

  const normalizedCodes = normalizePermissionCodes(permissionCodes);
  return requiredPermissions.some((permission) => normalizedCodes.includes(permission));
};
